import { AddressBook as AddressBookIcon } from "@phosphor-icons/react/AddressBook";
import { AlignLeft as AlignLeftIcon } from "@phosphor-icons/react/AlignLeft";
import { Article as LayerDetialIcon } from "@phosphor-icons/react/Article";
import { CalendarCheck as CalendarCheckIcon } from "@phosphor-icons/react/CalendarCheck";
import { ChartLine as AnalticsIcon } from "@phosphor-icons/react/ChartLine";
import { ChartPie as ChartPieIcon } from "@phosphor-icons/react/ChartPie";
import { ChatsCircle as ChatsCircleIcon } from "@phosphor-icons/react/ChatsCircle";
import { CreditCard as CreditCardIcon } from "@phosphor-icons/react/CreditCard";
import { Cube as CubeIcon } from "@phosphor-icons/react/Cube";
import { CurrencyEth as CurrencyEthIcon } from "@phosphor-icons/react/CurrencyEth";
import { CursorClick as PopupIcon } from "@phosphor-icons/react/CursorClick";
import { EnvelopeSimple as EnvelopeSimpleIcon } from "@phosphor-icons/react/EnvelopeSimple";
import { File as FileIcon } from "@phosphor-icons/react/File";
import { FileDashed as FileDashedIcon } from "@phosphor-icons/react/FileDashed";
import { FileX as FileXIcon } from "@phosphor-icons/react/FileX";
import {
	Gear as DetailsIcon,
	Gear as GearIcon,
} from "@phosphor-icons/react/Gear";
import { Globe as WhiteLabelIcon } from "@phosphor-icons/react/Globe";
import { GraduationCap as GraduationCapIcon } from "@phosphor-icons/react/GraduationCap";
import { Hash as AttributeFormatIcon } from "@phosphor-icons/react/Hash";
import { House as HouseIcon } from "@phosphor-icons/react/House";
import { Kanban as KanbanIcon } from "@phosphor-icons/react/Kanban";
import { Link as LinkIcon } from "@phosphor-icons/react/Link";
import { List as NavIcon } from "@phosphor-icons/react/List";
import { Lock as LockIcon } from "@phosphor-icons/react/Lock";
import { Monitor as PortalIcon } from "@phosphor-icons/react/Monitor";
import { PaintBrush as StyleIcon } from "@phosphor-icons/react/PaintBrush";
import { Palette as ThemeIcon } from "@phosphor-icons/react/Palette";
import { ReadCvLogo as ReadCvLogoIcon } from "@phosphor-icons/react/ReadCvLogo";
import { Receipt as ReceiptIcon } from "@phosphor-icons/react/Receipt";
import { ShareNetwork as ShareNetworkIcon } from "@phosphor-icons/react/ShareNetwork";
import { ShoppingBagOpen as ShoppingBagOpenIcon } from "@phosphor-icons/react/ShoppingBagOpen";
import { ShoppingCartSimple as ShoppingCartSimpleIcon } from "@phosphor-icons/react/ShoppingCartSimple";
import { SignOut as SignOutIcon } from "@phosphor-icons/react/SignOut";
import { TextAa as LabelsIcon } from "@phosphor-icons/react/TextAa";
import { TextAlignLeft as TextAlignLeftIcon } from "@phosphor-icons/react/TextAlignLeft";
import { Translate as LocalisationIcon } from "@phosphor-icons/react/Translate";
import { Truck as TruckIcon } from "@phosphor-icons/react/Truck";
import { Upload as UploadIcon } from "@phosphor-icons/react/Upload";
import { Users as UsersIcon } from "@phosphor-icons/react/Users";
import { WarningDiamond as WarningDiamondIcon } from "@phosphor-icons/react/WarningDiamond";

import type { Icon } from "@phosphor-icons/react/dist/lib/types";

export const icons = {
	"address-book": AddressBookIcon,
	"align-left": AlignLeftIcon,
	"calendar-check": CalendarCheckIcon,
	"chart-pie": ChartPieIcon,
	"chats-circle": ChatsCircleIcon,
	"credit-card": CreditCardIcon,
	"currency-eth": CurrencyEthIcon,
	"envelope-simple": EnvelopeSimpleIcon,
	"file-dashed": FileDashedIcon,
	"file-x": FileXIcon,
	"graduation-cap": GraduationCapIcon,
	"read-cv-logo": ReadCvLogoIcon,
	"share-network": ShareNetworkIcon,
	"shopping-bag-open": ShoppingBagOpenIcon,
	"shopping-cart-simple": ShoppingCartSimpleIcon,
	"sign-out": SignOutIcon,
	"text-align-left": TextAlignLeftIcon,
	"warning-diamond": WarningDiamondIcon,
	cube: CubeIcon,
	file: FileIcon,
	house: HouseIcon,
	kanban: KanbanIcon,
	link: LinkIcon,
	lock: LockIcon,
	receipt: ReceiptIcon,
	truck: TruckIcon,
	upload: UploadIcon,
	gear: GearIcon,
	users: UsersIcon,
	"details-icon": DetailsIcon,
	"nav-icon": NavIcon,
	"layer-details": LayerDetialIcon,
	style: StyleIcon,
	labels: LabelsIcon,
	popup: PopupIcon,
	"attribute-format": AttributeFormatIcon,
	"localisation-icon": LocalisationIcon,
	"theme-icon": ThemeIcon,
	"portal-icon": PortalIcon,
	"white-label-icon": WhiteLabelIcon,
	"analytics-icon": AnalticsIcon,
} as Record<string, Icon>;
